import React from 'react';

const InfluxerTheme = {
  headerLogo: {
    src: '/themes/theme/influxer/influxer-logo.png',
    alt: 'Influxer Agency Logo',
    size: 35,
  },
  darkLogo: {
    src: '/themes/theme/influxer/influxer-logo-dark.png',
    alt: 'Influxer Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '2px solid #fff',
    height: 50,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Influxer Data',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src="/themes/theme/influxer/influxer-logo-dark.png" alt="Influxer Agency Logo"
      />
      <br /><br />
      <h3>Influxer Agency Influencers</h3>
    </div>
  ),
  shareSite: 'https://brands.influxer.co.uk',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: 'https://creators.influxer.co.uk/themes/theme/influxer/influxer-logo-dark.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
};

export default InfluxerTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/influxer.js
 **/